import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import PlatformIntro from './components/PlatformIntro';
import SeoSection from './components/SeoSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <HeroSection />
        </article>
        <CategoryNav />
        <HotRecommend />
        <LatestUpdate />
        <PlatformIntro />
        <SeoSection />
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "芭乐视频 - 红桃视频、樱花视频高清免费在线观看 | 特色视频平台推荐",
        "description": "芭乐视频聚合红桃视频、樱花视频、糖豆视频等特色视频平台内容，提供高清免费在线观看，无需缓冲。",
        "url": "https://www.balevideo.com/",
        "isPartOf": {
          "@type": "WebSite",
          "name": "芭乐视频",
          "url": "https://www.balevideo.com/"
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.balevideo.com/" }
          ]
        }
      }) }} />
    </>
  );
}